<!-- <div class="justify-content-center align-content-center center-screen mt-2 mb-4">
  <div class="d-flex align-content-center justify-content-center my-3"> -->

<ng-container class="d-flex mt-3">
  <div fxLayout="row" class="container container-sm" fxLayoutAlign="center center" fxLayoutGap="6px">

    <form [formGroup]="ratesAndFeesForm" class="pt-3">
      <div class="card rounded-2 shadow-2-soft">
        <div class="card-header p-1">
          <div class="idlight ms-auto me-auto rounded-2 shadow-2-strong center-screen py-3">
            <div class="d-inline-flex justify-content-around align-content-center">
              <div *ngFor="let product of lstProductTypes; let i as index;" style="flex-wrap: nowrap;
                                  flex-grow: 1 auto;">
                <button type="button" class="btn me-2" mdbRipple rippleColor="dark" color="primary"
                  [ngClass]="{'btn-primary':ratesAndFeesModel.id == product.id, 'btn-outline-primary':ratesAndFeesModel.id != product.id}"
                  (click)="ratesAndFeesModel=product;showProduct(product);">{{product.description}}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body mb-2 p-3">
          <div class="container-fluid ms-auto me-auto">
            <div class="d-flex center-screen">
              <table id="productRates" w1100
                class="table table-striped table-fixed table-sm mb-2 shadow-2-strong rounded-1 p-1 my-2"
                [style.width.px]="1150" style="text-align: left;">
                <caption>Product Parameters</caption>
                <tbody class="field-4column-label">
                  <tr>
                    <td style="width: 30%;">Code</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="code" [(ngModel)]="ratesAndFeesModel.code">
                      <!-- <div *ngIf="validateRatesAndFeesValues.code.errors?.required && submitted" class="error-label">
                            Code is required
                          </div> -->
                    </td>

                    <td style="width: 30%;">Description</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="description"
                        [(ngModel)]="ratesAndFeesModel.description" required>
                      <div *ngIf="validateRatesAndFeesValues.description.errors?.required && submitted"
                        class="error-label">
                        Description is required
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 30%;">Minimum Loan Amount</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="minimumLoan"
                        [(ngModel)]="ratesAndFeesModel.minimumLoan" required>
                      <div *ngIf="validateRatesAndFeesValues.minimumLoan.errors?.required && submitted"
                        class="error-label">
                        Minimum loan is required
                      </div>
                    </td>

                    <td style="width: 30%;">Maximum Loan Amount</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="maximumLoan"
                        [(ngModel)]="ratesAndFeesModel.maximumLoan" required>
                      <div *ngIf="validateRatesAndFeesValues.maximumLoan.errors?.required && submitted"
                        class="error-label">
                        Maximum Loan is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">Interest rate 1st loan (%)</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="interestRate1st"
                        [(ngModel)]="ratesAndFeesModel.interestRate1st" required>
                      <div *ngIf="validateRatesAndFeesValues.interestRate1st.errors?.required && submitted"
                        class="error-label">
                        Interest rate 1st loan is required
                      </div>
                    </td>
                    <td style="width: 30%;">Interest rate other loans (%)</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="interestRateOther"
                        [(ngModel)]="ratesAndFeesModel.interestRateOther" required>
                      <div *ngIf="validateRatesAndFeesValues.interestRateOther.errors?.required && submitted"
                        class="error-label">
                        Interest rate other is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">Initiation fee if cap below 1000 (%)</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="initFeeBelow1000"
                        [(ngModel)]="ratesAndFeesModel.initFeeBelow1000">
                    </td>
                    <td style="width: 30%;">Initiation fee first 1000</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="initFeeFirst1000"
                        [(ngModel)]="ratesAndFeesModel.initFeeFirst1000">
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">Initiation fee (%)</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="initiationFee"
                        [(ngModel)]="ratesAndFeesModel.initiationFee" required>
                      <div *ngIf="validateRatesAndFeesValues.initiationFee.errors?.required && submitted"
                        class="error-label">
                        Initiation fee is required
                      </div>
                    </td>

                    <td style="width: 30%;">Initiation fee cap</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="initiationCap"
                        [(ngModel)]="ratesAndFeesModel.initiationCap" required>
                      <div *ngIf="validateRatesAndFeesValues.initiationCap.errors?.required && submitted"
                        class="error-label">
                        Initiation fee cap is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">My Benefits (%)</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="myBenefits"
                        [(ngModel)]="ratesAndFeesModel.myBenefits" required>
                      <div *ngIf="validateRatesAndFeesValues.myBenefits.errors?.required && submitted"
                        class="error-label">
                        My Benefits is required
                      </div>
                    </td>
                    <td style="width: 30%;">Term in months</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="term" [(ngModel)]="ratesAndFeesModel.term" required>
                      <div *ngIf="validateRatesAndFeesValues.term.errors?.required && submitted" class="error-label">
                        Term is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">Factor 1st loan</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="factor1stLoan"
                        [(ngModel)]="ratesAndFeesModel.factor1stLoan">
                    </td>
                    <td style="width: 30%;">Factor other loans</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="factorOtherLoan"
                        [(ngModel)]="ratesAndFeesModel.factorOtherLoan">
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 27%;">Factor up to 850</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="factorUpTo850"
                        [(ngModel)]="ratesAndFeesModel.factorUpTo850">
                    </td>
                    <td style="width: 27%;">Factor up to 1000</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="factorUpTo1000"
                        [(ngModel)]="ratesAndFeesModel.factorUpTo1000">
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 27%;">Monthly service fee</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="monthlyServiceFee"
                        [(ngModel)]="ratesAndFeesModel.monthlyServiceFee" required>
                      <div *ngIf="validateRatesAndFeesValues.monthlyServiceFee.errors?.required && submitted"
                        class="error-label">
                        Monthly service fee is required
                      </div>
                    </td>
                    <td style="width: 27%;">Initiation service fee cap (%)</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="initServiceFeeCap"
                        [(ngModel)]="ratesAndFeesModel.initServiceFeeCap" required>
                      <div *ngIf="validateRatesAndFeesValues.initServiceFeeCap.errors?.required && submitted"
                        class="error-label">
                        Initiation service fee cap is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">Max days before first payment</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="maxDays" [(ngModel)]="ratesAndFeesModel.maxDays" required>
                      <div *ngIf="validateRatesAndFeesValues.maxDays.errors?.required && submitted" class="error-label">
                        Max days before first payment is required
                      </div>
                    </td>
                    <td style="width: 30%;">Regulatory type</td>
                    <td style="width: 23%;">
                      <mdb-select class="select table-control" formControlName="regulatoryType"
                        [(ngModel)]="ratesAndFeesModel.regulatoryType" required>
                        <mdb-option *ngFor="let regType of lstRegulatory;" [value]="regType.value">
                          {{regType.description}}
                        </mdb-option>
                      </mdb-select>
                      <div *ngIf="validateRatesAndFeesValues.regulatoryType.errors?.required && submitted"
                        class="error-label">
                        Regulatory type is required
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 30%;">MyBenefits Document tier</td>
                    <td style="width: 23%;">
                      <mdb-select class="select table-control " formControlName="mybenefitsTier"
                        (change)="onSelect($event)" required>
                        <mdb-option *ngFor="let myben of lstmyBenefitTier;" [value]="myben.value">
                          {{myben.description}}
                        </mdb-option>
                      </mdb-select>
                      <div *ngIf="validateRatesAndFeesValues.mybenefitsTier.errors?.required && submitted"
                        class="error-label">
                        MyBenefits document tier is required
                      </div>
                    </td>
                    <td style="width: 30%;" colspan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex center-screen">
              <!-- Product Fee calculations -->
              <table id="serviceFees" class="table table-striped table-sm mb-2 shadow-2-strong rounded-1 p-1 my-2"
                [style.width.px]="1150" style="text-align: left;">
                <caption>Product Fee calculations</caption>
                <tbody class="field-4column-label">
                  <tr>
                    <td style="width: 30%;">Loan Type</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="type" [(ngModel)]="ratesAndFeesModel.type" required>
                      <div *ngIf="validateRatesAndFeesValues.type.errors?.required && submitted" class="error-label">
                        Loan type is required
                      </div>
                    </td>
                    <td style="width: 30%;">Regulatory type</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="regulatoryType"
                        [(ngModel)]="ratesAndFeesModel.regulatoryType">
                      <div *ngIf="validateRatesAndFeesValues.regulatoryType.errors?.required && submitted"
                        class="error-label">
                        Regulatory type is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 30%;">Max days before first payment</td>
                    <td style="width: 23%;">
                      <input type="text" class="form-control" style="width: 240px;" formControlName="maxDays" [(ngModel)]="ratesAndFeesModel.maxDays" required>
                      <div *ngIf="validateRatesAndFeesValues.maxDays.errors?.required && submitted" class="error-label">
                        Max days before first payment is required
                      </div>
                    </td>

                    <td style="width: 30%;">Calculation type</td>
                    <td style="width: 23%;">
                      <input style="width: 240px;" formControlName="calculationType" class="form-control" type="text" [(ngModel)]="ratesAndFeesModel.calculationType">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div><!-- END: card-body -->
        <div class="card-footer flex-container">
          <button class="btn btn-danger me-5" (click)="openDeleteProductDialog(ratesAndFeesModel)">
            <i class="fas fa-trash-can  fa-fw me-1"></i>
            Delete Product
          </button>
          <button class="btn btn-primary" mdbRipple (click)="openAddProductDialog()">
            <i class="fas fa-laptop-medical fa-fw me-1"></i>
            Add New
          </button>
          <button class="btn btn-primary " mdbRipple (click)="saveUpdateLoanType(ratesAndFeesModel)">Save
          </button>
        </div>

      </div><!-- END: card -->
    </form>
  </div>
</ng-container>
